import { REACT_APP_TENANT_SEQ } from './environment';

export const EXPERIMENTS = 'experiments';
export const GXS = 'gxs';
export const GRAB = 'grab';
export const MOVEIT = 'moveit';
export const MOVEITSOURCE = 'MoveIT';
export const GXB = 'gxb';
export const CHOPE = 'chope';
export const OVO = 'ovo';
export const MEXLITE = 'mexlite';

export const SSO_LOGIN_TENANT = [GXS, GXB];

/** Gets tenant from window.location */
export function getTenant(): string {
  const wwwRegex = /www\.*/i;
  const envRegex = /[-]*stg/i;
  const hostname = window.location.hostname.replace(wwwRegex, '');
  // gxs.grab-x.net || gxs-stg.grab-x.net || experiments.grab.com || experiments.stg-myteksi.net || moveit.grab-x.net || moveit-stg.grab-x.net
  // ||  gxb.grab-x.net || gxb-stg.grab-x.net || chope.grab-x.net || chope-stg.grab-x.net || ovo.grab-x.net || ovo-stg.grab-x.net
  const tenantEnv = hostname.split('.')[0];
  return tenantEnv.replace(envRegex, '');
}

export function isSSOLoginTenant(): boolean {
  return SSO_LOGIN_TENANT.includes(getTenant());
}

export function getSource(): string {
  return isMoveITTenant() ? MOVEITSOURCE : '';
}

export function isMoveITTenant(): boolean {
  return getTenant() === MOVEIT;
}

export function isChopeTenant(): boolean {
  return getTenant() === CHOPE;
}

export function isOvoTenant(): boolean {
  return getTenant() === OVO;
}

export function isMexLiteTenant(): boolean {
  return getTenant() === MEXLITE;
}

export function getTenantSeqNumber(): number {
  return parseInt(REACT_APP_TENANT_SEQ, 10) || 1;
}
